import Script from 'next/script';
import { useState, useMemo, useEffect } from 'react';

import { logger } from '#utils/logging/logger';

/**
 * Regexp used to extract the box identifier from the embed source.
 */
const EBU_REF_REGEXP = /box=\s*(["']?)([^"'\s>]*)\1/;

/**
 * This is the classname used by the EBU embed script to identify the newsbox
 */
const EBU_CLASS_NAME = 'pilotreco';

export function EBUEmbed({ source }: { source: string }) {
	// The ebu-service must not be wrapped inside an iframe because it needs a reference to the window object
	const [ebuScriptLoaded, setEbuScriptLoaded] = useState(false);

	const ebuIdentifier = useMemo(() => {
		// Extract the EBU box identifier from the source
		const match = EBU_REF_REGEXP.exec(source);
		if (match?.[2]) {
			return match[2];
		} else {
			logger.error('Could not get box identifier from EBU source');
			return undefined;
		}
	}, [source]);

	// When the EBU script is loaded or the ebuIdentifier changes call the EBU initialization function
	useEffect(() => {
		// eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
		if (ebuScriptLoaded) {
			try {
				window.NewsPilotReco?.();
			} catch (e: any) {
				logger.error(e, `EBU embed client side error`);
			}
		}
	}, [ebuScriptLoaded, ebuIdentifier]);

	return (
		<>
			<Script
				src="https://reco.ebu.io/news-reco-br.js"
				onReady={() => {
					setEbuScriptLoaded(true);
				}}
			/>
			{/*  @ts-expect-error box is a non standard attribute used by the embed */}
			<div className={EBU_CLASS_NAME} box={ebuIdentifier} />
		</>
	);
}
